import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { serviceURLService } from '../service/serviceURL';
import { DatePipe } from '@angular/common';
import { ToasterService } from '../services/toaster.service';
import * as XLSX from 'xlsx';
import { forkJoin } from 'rxjs';
import { HttpHeaders } from "@angular/common/http";
import *  as  s3_logo_path from '../e-cards/s3-logo-path.json'
import html2pdf from 'html2pdf.js'
import jsPDF from 'jspdf';

@Component({
  selector: "app-view-endorsements",
  templateUrl: "./view-endorsements.component.html",
  styleUrls: ["./view-endorsements.component.css"],
  providers: [ToasterService]
})
export class ViewEndorsementsComponent implements OnInit {
  insuranceDetails: Array<any> = [];
  s3LogoList: any = (s3_logo_path as any).default;
  typeOf: String = "";
  addMoreEmp: Boolean = false;
  empObj:any={
    "empId": "",
    "name": "",
    "age": "",
    "gender": "",
    "relation": "Self",
    "sumInsured": "",
    "email": "",
    "dob":"",
    "doj":"",
    "mobile":'',
    "cardNo":"",
    "actionType":"Addition"
  };
  deleteModalOpen: Boolean = false;
  inProgressBtnFlag: Boolean = false;
  typeOfForBtns: String = "";
  headerType: String = "";
  previewDetails: Boolean = true;
  deleteModalProceedOpen: Boolean = false;
  policyNumber:String='';
  insurerCode:String='';
  endDate:String='';
  policyMobileNumber:String='';
  productName:String=''
  loading:Boolean=false;
  activeCardArr:Array<any>=[];
  selectedDetailedObj:Object={};
  indexOfSelected:String='';
  expandDataPresent:Boolean=false;
  storeCardsArr:Array<any>=[];
  cdBalance:Number;
  filteredItems: any[] = [];
  selectAll:Boolean=false;
  deleteEndoCards:Array<any>=[];
  clientId:String='';
  insurerId:String='';
  sumInsured:String='';
  proRatePremiumArray:Array<any>=[];
  tokenForApi:String='';
  endorsementBatchModal:Boolean=false;
  endoBatchesArr:Array<any>=[];
  startDate:String='';
  employeesByBatchIdModal:Boolean=false;
  employeeByBatchArr:Array<any>=[];
  batchDetailsFromBatchIdModal:Boolean=false;;
  batchDetailsFromBatchObj:any={};
  updateEmployeeModal:Boolean=false;
  updateSuccessMessage:String="";
  errorMessageForAdding:String="";
  calculateCardName:String="";
  excelUploadData:Array<any>=[];
  addCalcPremiumArray:Array<any>=[];
  addCardsPremiumArr:Array<any>=[];
  excelValMessage:String="";
  sumInsuredCalc:String="";
  editModalOpen:Boolean=false;
  cdNameId:String="";
  editObj:any={
    "empId": "",
    "name": "",
    "age": "",
    "gender": "",
    "relation": "",
    "sumInsured": "",
    "email": "",
    "dob":"",
    "doj":"",
    "mobile":'',
    "cardNo":"",
    "actionType":""
  };
  apiCallForToken:Boolean=true;
  holdCdBalance:any;
  maxDate:String;
  blurBackGround:Boolean=false;
  formType: String = "";
  familyDefitionArr:any[]=[];
  currentStep: number = 1;
  familyDataArr:any[]=[];
  saveAndReviewBool:Boolean=false;
  familyDetails:Boolean=false;
  isCollapsed:Boolean=false;
  isCollapsed2:Boolean=false;
  searchVal:String='';
  productId:String='';
  proceedAndReviewBool:Boolean=false;
  saveDetailsBool:Boolean=false;
  editModalBool:boolean=false;
  policyholder:String="";
  policyEmail:String="";
  insurerName:String="";
  updatedColumn:Array<any>=[];
  updatedColumnEdit:Array<any>=[];
  updateModalBool:Boolean=false;
  toDelete:number;
  batchType:String=""
  editModalErrorMessage:String="";
  toggleDateForSelf:Boolean=false;
  toggleForFam:any=[];
  toggleForFamDelete: { toggleDateForSelf: boolean,toggleDateForDob:boolean}[] = [];
  toggleForFamEdit: { toggleDateForDob:boolean,toggleDateForDoj:boolean}={ toggleDateForDob:false,toggleDateForDoj:false};
  toggleDoj:Boolean=false;
  fileUploadBool:Boolean=false;
  fileUploadBool2:Boolean=false;
  idendtityFile='';
  uploadErrorMessage=''
  goFromActiveCardsForSelf:Boolean=false;
  goFromActiveCardsForFamily:Boolean=false;
  uploadedFileName:String;
  isManagerialLogin:boolean=false;
  familyDefinitionFlag:String='';
  isClinetNFI:boolean=false;
  isValidRelation:Boolean=true;
  isParentVisible:Boolean=true;
  isInLawParentsVisible:Boolean=true;
  selectedRelations = {
    Father: false,
    Mother: false,
    'Father In Law': false,
    'Mother In Law': false,
  };
  infoMessage = 'Addition of parents and parents-in-law is not permitted during the mid-term of the policy period through the Endorsement portal. For further assistance, please contact us at support@securenow.in ';
  constructor(private route: ActivatedRoute,private serviceURLService: serviceURLService,private datePipe: DatePipe,private toasterService: ToasterService) {}

 async ngOnInit() {
    // this.route.queryParams.subscribe((sessionData.=> {
      let sessionData=JSON.parse(sessionStorage.getItem("policyDetailsEndorsement"))
      this.isManagerialLogin = JSON.parse(localStorage.getItem('isManagerialLogin'));
      this.typeOf = sessionData.type
      this.typeOfForBtns = sessionData.type
      this.productId = sessionData.productId
      this.policyNumber=sessionData.policyNumber
        this.insurerCode=sessionData.insurerCode
        this.endDate=sessionData.endDate
        this.startDate=sessionData.startDate
        this.productName=sessionData.productName
        this.clientId=sessionData.clientId
        this.insurerId=sessionData.insurerId
        this.sumInsured=sessionData.sumInsured
        this.cdNameId=sessionData.cdNameId
        this.policyMobileNumber=sessionData.mobileNumber
        this.policyholder=sessionData.policyHolder
        this.policyEmail=sessionData.policyEmail
        this.insurerName=sessionData.insurerName
        this.familyDefinitionFlag = sessionData.familyDefinition ? sessionData.familyDefinition : 'all';
      if (
        this.typeOfForBtns!='view'
      ) {
        this.inProgressBtnFlag = true;
      }
      if (
        this.typeOfForBtns === "edit" ||
        this.typeOfForBtns === "delete"
      ) {
        this.typeOfForBtns = 'view';
      }
      if (
        this.typeOfForBtns === "upload"
      ) {
        this.typeOfForBtns = 'add';
      }
      if (this.typeOf === "view"||this.typeOf === "edit"||this.typeOf === "delete") {
        this.headerType = "Active eCards";
      } else if (this.typeOf === "upload") {
        this.headerType = "Addition Calculation";
        this.formType="add"
      }else if (this.typeOf === "add") {
        this.headerType = "Addition Calculation";
        this.formType="addForm"
      }  
      else if (this.typeOf === "delete") {
        this.headerType = "Deletion Calculation";
      } else if (this.typeOf === "edit") {
        this.headerType = "Updation";
      }

      
      if((!!localStorage.getItem('pamClientId') && localStorage.getItem('pamClientId').toLowerCase() === "738113".toLowerCase())
        || (!! localStorage.getItem('companyName') && localStorage.getItem('companyName').toLowerCase().trim() === "National Foundation for India-CSOs".toLowerCase().trim())){
        this.isClinetNFI = true
      }
    // });
    this.setDate()
    this.calculateCardName=await this.calulateCardName(this.insurerCode,this.productName,this.policyNumber);
      this.getAllActiveEcards(this.endDate)

      this.serviceURLService.getDownloadEcards({
        cardName: this.calculateCardName,
        endDate: this.endDate
      }).subscribe((successData: any) => {
        this.insuranceDetails = successData.response;
      })
  }

  setDate() {
    const dtToday = new Date();

    const month = (dtToday.getMonth() + 1).toString().padStart(2, '0');
    const day = dtToday.getDate().toString().padStart(2, '0');
    const year = dtToday.getFullYear();

    this.maxDate = `${year}-${month}-${day}`;
  }

  async getAllActiveEcards(endDate){
    let api;
    if(this.typeOfForBtns==='view'){
      api="getAllActiveEcards"
    }
    else  if(this.typeOfForBtns==='add'){
      api="additionTempInNotify"
    }
    else  if(this.typeOfForBtns==='edit'){
      api="updationProgressActiveEcardsApi"
    }
    else  if(this.typeOfForBtns==='delete'){
      api="deletionInProgressActiveEcards"
    }
    this.loading=true
    let payLoad={
      cardName:this.calculateCardName,
      endDate:endDate
    }
     this.serviceURLService[api](payLoad).subscribe((successData: any) => {
    //  this.loading=true
       this.activeCardArr= api==="updationProgressActiveEcardsApi"?successData.response.pendingUpdate:
       api==="deletionInProgressActiveEcards"?successData.response.allDeletedPendingPolicy:
       successData.response

       for (let index = 0; index < this.activeCardArr.length; index++) {
         const dateCreated =new Date( this.activeCardArr[index].created);
         const formattedDate = this.datePipe.transform(dateCreated,"dd/MM/yyyy" );
         
         // Format the time in hh:mm a format (AM/PM)
         const formattedTime = this.datePipe.transform(dateCreated, "hh:mm a");
         this.activeCardArr[index].dateCreated=formattedDate;
         this.activeCardArr[index].timeCreated=formattedTime;
         
         if(index%2==0){
           this.activeCardArr[index].bgColor='white'
         }
         
       }
       this.filteredItems=this.activeCardArr
       this.loading=false
     }, errorData => {
      this.activeCardArr=[]
       this.loading=false
     });
    this.serviceURLService.getHoldCdBalance(this.clientId,this.insurerId,this.cdNameId,this.productId).subscribe((successData: any) =>{
      this.cdBalance = successData.data.balance;
      this.holdCdBalance=successData.data.totalHoldCdBalance;
      // if(this.holdCdBalance>this.cdBalance){
      //   this.cdBalanceBool=true
      // }
      // this.loading=false
    }, errorData => {
      this.activeCardArr=[]
      //  this.loading=false
     });
   
   }
  addEmployeeModalOpen() {
    this.formType = "addForm";
    this.headerType="Addition Calculation"
    this.typeOfForBtns = "add";
    this.goFromActiveCardsForSelf=true;
    this.familyDefitionArr=[]
    this.familyDataArr=[]
    this.goFromActiveCardsForFamily=true;
    this.empObj={
      "empId": "",
      "name": "",
      "age": "",
      "gender": "",
      "relation": "Self",
      "sumInsured": "",
      "email": "",
      "dob":"",
      "doj":"",
      "mobile":'',
      "cardNo":"",
      "actionType":"Addition"
    };
    // this.blurBackGround=true;
  }

  additionInProgressAgain(){
    this.formType="add"
  }

  closeAddModal = () => {
    this.typeOf = "";
    this.excelValMessage=''
    this.blurBackGround=false
    this.uploadedFileName=''
  };

  onKeyDown(event) {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }
  
  handleChangeEmp = (event) => {
    var { name, value } = event.target;
    value = value.trim();
    this.empObj = {
      ...this.empObj,
      [name]: value,
    };
    if(name==="doj"){
      this.toggleDoj=true
    }
    else if(name==="dob"){
      this.toggleDateForSelf=true
    }
};

  proceedAndReview=()=>{
    this.proceedAndReviewBool=false
    this.saveAndReviewBool=true;
  }

  closePreviewAndReview=()=>{
    this.proceedAndReviewBool=false
  }

  commonValidation=()=>{
    let allConditionsMet = true;
    const dob = new Date(this.empObj.dob);
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    const regForEmail = RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    const policyStartDate = new Date(this.startDate.replace(/-/g, "/"));
    const joiningDate = new Date(this.empObj.doj);
    const currentDate = new Date();
    const thirtyDaysAgo = new Date(currentDate);
    thirtyDaysAgo.setDate(currentDate.getDate() - 30);
   if(this.goFromActiveCardsForFamily&&this.goFromActiveCardsForSelf){
    if(!this.empObj.name){
      this.errorMessageForAdding="Name is required"
      allConditionsMet = false;
    }
    else if(!this.empObj.empId){
      this.errorMessageForAdding="Employee ID is required"
      allConditionsMet = false;
    }
    else if(!this.empObj.actionType){
      this.errorMessageForAdding="Endorsement type is required"
      allConditionsMet = false;
    }
    else if(!this.empObj.dob){
      this.errorMessageForAdding="Date of birth is required"
      allConditionsMet = false;
    }
    else if (dob > eighteenYearsAgo) {
      this.errorMessageForAdding="Date of birth should be 18 years or above"
      allConditionsMet = false;
    }
    else if(!this.empObj.gender){
      this.errorMessageForAdding="Gender is required"
      allConditionsMet = false;
    }
    else if(!this.empObj.sumInsured){
      this.errorMessageForAdding="Sum Insured is required"
      allConditionsMet = false;
    }
    else if(this.empObj.sumInsured<0){
      this.errorMessageForAdding="Sum Insured cannot be less than 0"
      allConditionsMet = false;
    }
    else if(!this.empObj.doj){
      this.errorMessageForAdding="Date of joining is required"
      allConditionsMet = false;
    }
    else if (joiningDate < thirtyDaysAgo) {
      this.errorMessageForAdding = "Employee date of joining can't be greater than 30 days from today";
      allConditionsMet = false;
    } 
    else if (joiningDate < policyStartDate) {
      this.errorMessageForAdding = 'Joining Date is smaller than PolicyStartDate'
      allConditionsMet = false;
    }
    else if(!this.empObj.mobile){
      this.errorMessageForAdding="Mobile is required"
      allConditionsMet = false;
    }
    else if(!this.empObj.email){
      this.errorMessageForAdding="Email is required"
      allConditionsMet = false;
    }
     else if(!regForEmail.test(this.empObj.email)){
      this.errorMessageForAdding="Email is invalid"
      allConditionsMet = false;
    }else if(this.familyDefitionArr.length > 0){
      const twentyFiveYearsAgo = new Date();
      twentyFiveYearsAgo.setFullYear(twentyFiveYearsAgo.getFullYear() - 25);
      twentyFiveYearsAgo.setHours(0, 0, 0, 0);
      for (let index = 0; index < this.familyDefitionArr.length; index++) {
        let famDef = this.familyDataArr[index];
        let element = this.familyDefitionArr[index];
        const dob = new Date(famDef.dob);
        dob.setHours(0, 0, 0, 0); // Normalize time to midnight
        if(element.includes("Child") && dob < twentyFiveYearsAgo){
          this.errorMessageForAdding = element + " Date of birth should not be 25 years or above.";
          allConditionsMet = false;
        }
      }
    }
    if(allConditionsMet){
      this.familyDetails=true;
      this.proceedAndReviewBool=true
      this.errorMessageForAdding=''
    }
   }
   else if (this.familyDefitionArr.length > 0) {
      const thirtyDaysFromNow = new Date();
      thirtyDaysFromNow.setDate(currentDate.getDate() - 30);
       let allConditionsMet = true;
       
       for (let index = 0; index < this.familyDefitionArr.length; index++) {
         let famDef = this.familyDataArr[index];
        let element = this.familyDefitionArr[index];
    
        if (!famDef) {
          this.errorMessageForAdding = "Please fill all values";
          allConditionsMet = false;
          break;
        }
    
        if (!famDef.name || famDef.name === undefined) {
          this.errorMessageForAdding = element + " Name is required";
          allConditionsMet = false;
          break;
        } else if (!famDef.dob) {
          this.errorMessageForAdding = element + " Date of birth is required";
          allConditionsMet = false;
          break;
        }
       else if (this.goFromActiveCardsForFamily &&(element.includes("Child"))&& (new Date(famDef.dob) < thirtyDaysFromNow || new Date(famDef.dob) > currentDate)) {
           this.errorMessageForAdding = element + " Date of Birth can't be greater than 30 days";
          allConditionsMet = false;
          break;
        }
         else {
          const thirtyDaysFromNow = new Date();
          thirtyDaysFromNow.setDate(currentDate.getDate() - 30);
          // Assuming dob is a valid Date object representing the date of birth
          const dob = new Date(famDef.dob);
          const marrDob = new Date(famDef.marrDob);
    
          // Calculate eighteen years ago from today
          const eighteenYearsAgo = new Date();
          eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    
          if (dob > eighteenYearsAgo && !element.includes("Child")) {
            this.errorMessageForAdding = element + " Date of birth should be 18 years or above";
            allConditionsMet = false;
            break;
          }
          if (this.goFromActiveCardsForFamily && (marrDob < thirtyDaysFromNow || marrDob > currentDate)) {
            this.errorMessageForAdding =  " Marriage Certificate Date cannot be more than 30 days";
            allConditionsMet = false;
            break;
          }
        }
    
        if (!famDef.gender) {
          this.errorMessageForAdding = element + " Gender is required";
          allConditionsMet = false;
          break;
        } else if (famDef.name && famDef.dob && famDef.gender) {
          // No need to set saveAndReviewBool and familyDetails here.
          // We will do it after the loop based on the allConditionsMet flag.
        }
      }
    
      if (allConditionsMet) {
        this.familyDetails = true;
        this.proceedAndReviewBool=true
        this.errorMessageForAdding=''
      }
    }
    else{
      this.familyDetails=true;
      this.proceedAndReviewBool=true
      this.errorMessageForAdding=''
    }
    
  }
  saveAndReview=()=>{
    this.commonValidation()
    if(this.errorMessageForAdding){
      setTimeout(()=>{
        this.errorMessageForAdding=''
      },5000)
    }
  }

  saveDetailsFunc=()=>{
    this.commonValidation()
    if(!this.errorMessageForAdding){
      this.saveDetailsBool=true
    }
  }

  closeSaveDetailsFunc=()=>{
    this.saveDetailsBool=false
  }

  commonPayload=(saveEndoPayload,endoresementType)=>{
    if(this.familyDefinitionFlag.toLowerCase() === '2 parents' || this.familyDefinitionFlag.toLowerCase() === '2 parents/parent in laws'.toLowerCase()){
      saveEndoPayload.userList = saveEndoPayload.userList.filter(item => item.relation.toLowerCase() !== "Self".toLocaleLowerCase());
    }
    
    this.loading=true
    this.serviceURLService.saveEmloyeeTempInNotify(saveEndoPayload).subscribe(
      (successData: any) => {
        if(successData.error){
          this.toasterService.showErrorToasterEndo("Access Denied,Please log in with the mobile number associated with the policy.");
        }else{
          this.toasterService.showErrorToasterEndo('Employee added successfully to addition queue');
        }
        this.getAllActiveEcards(this.endDate);
        this.blurBackGround=false;
    for (const key in this.empObj) {
      this.empObj[key] = "";
    }
    if(endoresementType==="Addition"){
    this.empObj['actionType']="Addition"
    this.empObj['relation']="Self"
    this.saveAndReviewBool=false
    this.familyDefitionArr=[]
    this.familyDataArr=[]
    this.familyDetails=false;
    this.formType="add"
    this.saveDetailsBool=false;
    this.proceedAndReviewBool=false
    }
    else{
    this.toasterService.showErrorToasterEndo('Employee(s) moved to Deletion Calculation successfully');
    this.deleteModalOpen=false
    }
      },
      (errorData) => {
        this.toasterService.showErrorToasterEndo(errorData.error.message);
      }
    );
  }
  submitEmployeeData = () => {
    this.commonValidation()
    if(!this.errorMessageForAdding){
      // this.errorMessageForAdding='';
      let mapArr=this.familyDataArr
      mapArr = mapArr.map((element, index) => {
        let relation = this.familyDefitionArr[index]
        let gender = element.gender; // Assuming there's a property named 'gender' in your 'element'
      
        // Mapping relations based on gender
        if (relation.includes("Child") && gender === "Male") {
          relation = "son";
        } else if (relation.includes("Spouse") && gender === "Male") {
          relation = "husband";
        } else if (relation.includes("Spouse") && gender === "Female") {
          relation = "wife";
        } else if (relation.includes("Child") && gender === "Female") {
          relation = "daughter";
        }
        return {
          ...element,
          empId: this.empObj.empId,
          age:'',
          email:this.empObj.email,
          sumInsured: this.empObj.sumInsured,
          doj: this.empObj.doj,
          mobile: this.empObj.mobile,
          cardNo: this.empObj.cardNo,
          actionType: this.empObj.actionType,
          relation: relation,
        };
      });
      
      mapArr.unshift(this.empObj)
      let saveEndoPayload={
        manager:{
          "mobile":localStorage.getItem("mobileNumber"),
          "policyNum":this.policyNumber,
          "startdate":this.startDate,
          "enddate":this.endDate,
          "insurer":"app",
          "source":"app"
        },
        userList:
        mapArr
      }
      this.commonPayload(saveEndoPayload,"Addition")
    
    }
  
}

  onKeyDownMobile=(event)=>{;
    const keyCode = event.which || event.keyCode;

    // Allow digits (0-9) and certain control keys (e.g., Backspace, Delete, Arrow keys)
    const allowedKeyCodes = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 8, 37, 39, 46];

    if (event.key === 'e' || event.key === 'E'||!allowedKeyCodes.includes(keyCode)) {
      event.preventDefault();
    }
}

  openUploadExcelBtn = () => {
    this.typeOf = "upload";
    this.blurBackGround=true
  };

  bulkDelete = () => {
    this.storeCardsArr.forEach(element => {
     if(element.dob){
      element.disableDate=true
     }
   });
    if(this.storeCardsArr.length==0){
      this.toasterService.showErrorToasterEndo('Please select at least one e-card');
    }
    else{
      this.storeCardsArr.forEach((ele,i)=>{
        if(ele.dob){
        this.toggleForFamDelete[i] = {...this.toggleForFamDelete[i],toggleDateForDob: true };
        }
      })
      this.deleteModalOpen = true;
      this.blurBackGround=true;
    }
  };

  closeDeleteModal = () => {
    this.deleteModalOpen = false;
    this.storeCardsArr=[];
    this.selectAll=false;
    this.blurBackGround=false;
    for (let index = 0; index < this.activeCardArr.length; index++) {
     this.activeCardArr[index].isChecked=false
     if(index%2==0){
      this.activeCardArr[index].bgColor='white'
    }
    else{
      this.activeCardArr[index].bgColor='#e8eaee'
    }
    }
  };

  inProgressButtonCall = () => {
    this.inProgressBtnFlag = true;
  };

  openConfirmModalUpdate=(id)=>{
    if(this.fileUploadBool&&this.fileUploadBool2){
      if (!this.storeCardsArr[id].documentType || !this.idendtityFile) {
        this.uploadErrorMessage="Document type and document are required if name is changed"
        setTimeout(() => {
          this.uploadErrorMessage=''
        }, 3000);
      }
      this.fileUploadBool2=false
    }
    else{
      this.updateModalBool=true
      this.toDelete=id
      this.uploadErrorMessage=''
    }
  }
  closeConfirmUpdateModal=()=>{
    this.updateModalBool=false
    this.fileUploadBool=false
  }

  updateEmployee = () => {
    if(this.storeCardsArr.length<=0){
      this.toasterService.showErrorToasterEndo("Please select at lease one e-card");
    }
    else{
      this.updateEmployeeModal=true;
    this.blurBackGround=true;
    }
  };

  handleUpdatedValues = (event, i) => {
    const { name, value } = event.target;
    const oldValue = this.storeCardsArr[i][name];
    
    if (oldValue !== value) {
        // Update the storeCardsArr
        this.storeCardsArr[i] = {
            ...this.storeCardsArr[i],
            [name]: value
        };

        // Update the updatedColumn array
        const updatedColumnIndex = this.updatedColumn.findIndex(item => item.columnName === name);
        if (updatedColumnIndex !== -1) {
            this.updatedColumn[updatedColumnIndex] = {
                "columnName": name,
                "oldValue": oldValue,
            };
        } else {
            this.updatedColumn.push({
                "columnName": name,
                "oldValue": oldValue,
            });
        }
      }
      if(name==="name"&&oldValue !== value){    
        this.fileUploadBool=true
    }
};

  closeUpdateModal=()=>{
    this.updateEmployeeModal=false;
    this.fileUploadBool=false
    this.blurBackGround=false;
    for (let index = 0; index < this.activeCardArr.length; index++) {
      this.activeCardArr[index].isChecked=false
      if(index%2==0){
       this.activeCardArr[index].bgColor='white'
     }
     else{
       this.activeCardArr[index].bgColor='#e8eaee'
     }
     }
     this.storeCardsArr=[];
    this.selectAll=false;
  }

  buttonsSectionFucn = (type) => {
    if (type === "view") {
      this.headerType = "Active eCards";
      this.typeOfForBtns = "view";
    } else if (type === "add") {
      this.headerType = "Addition Calculation";
      this.formType='add'
      this.typeOfForBtns = "add";
    } else if (type === "delete") {
      this.headerType = "Deletion Calculation";
      this.typeOfForBtns = "delete";
    } else if (type === "edit") {
      this.headerType = "Updation";
      this.typeOfForBtns = "edit";
    }
    this.getAllActiveEcards(this.endDate)
    this.storeCardsArr=[];
    this.selectAll=false
    this.searchVal=''
  };

  closePreview = () => {
    this.previewDetails = false;
  };

  previewCalculatedPremium=(endorsementType)=>{
    // if(this.cdBalanceBool&&endorsementType==="Addition"){
    //   this.toasterService.showErrorToasterEndo("Your endorsement cannot be processed due to insufficient CD Balance. Please top up your CD Balance to proceed with the endorsement.");
    // }
    // else{
    this.loading=true
    let payLoadDeleteArr=[];
    for (let i  = 0;  i< this.storeCardsArr.length; i++) {
      let obj={
        cardId:this.storeCardsArr[i].cardNo,
        dateOfBirth:new Date(this.storeCardsArr[i].dob),
        email:this.storeCardsArr[i].email,
        employeeNo:this.storeCardsArr[i].empId,
        endorsementType:endorsementType,
        gender:this.storeCardsArr[i].gender,
        dateOfJoin:endorsementType==="Addition"?new Date(this.storeCardsArr[i].doj):null,
        leavingDate:endorsementType==="Deletion"?new Date(this.storeCardsArr[i].dor):null,
        mobile:this.storeCardsArr[i].mobile,
        name:this.storeCardsArr[i].name,
        relationShipType:this.storeCardsArr[i].relation,
        sumInsured:this.storeCardsArr[i].sumInsured,

      }
      payLoadDeleteArr.push(obj)
    }
    let payLoad={
      clienId:this.clientId,
      endorsementGreyHrDtoList:payLoadDeleteArr,
      insuerId:this.insurerId,
      policyNumber:this.policyNumber,
      productId:this.productId,
    }
    this.serviceURLService.PreviewPremiumApi(payLoad).subscribe((successData: any) => {
      let data=successData.response.pamResponse
      this.loading=false;
      if(data.status!=400){
        this.deleteModalProceedOpen = true;
        this.blurBackGround=true;
        this.proRatePremiumArray=data.data.list;
        this.sumInsuredCalc=data.data.Total
      }
      else{
        this.toasterService.showErrorToasterEndo(data.message);
      }
     
          }, errorData => {
            this.loading=false;
            this.toasterService.showErrorToasterEndo(errorData.error.message);
          });
        // }
        
  }
  proceedDeleteEmp = (endorsementType) => {
    if(this.storeCardsArr.length<=0){
      this.toasterService.showErrorToasterEndo("Please select at least one employee");
    }
    else {
      let allResigned = true;
      for (const card of this.storeCardsArr) {
          if (!card.dor) {
              allResigned = false;
              break; // Exit the loop early if any card is missing a resignation date
          }
      }

      if (!allResigned) {
          this.toasterService.showErrorToasterEndo("Date of Resignation is mandatory for all employees");
      } else {
        // this.errorMessageForAdding='';
      let mapArr=this.storeCardsArr
      mapArr = mapArr.map((element, index) => {
        let relation = this.storeCardsArr[index].relation
        let gender = element.gender; // Assuming there's a property named 'gender' in your 'element'
      
        // Mapping relations based on gender
        if (relation.includes("Child") && gender === "Male") {
          relation = "son";
        } else if (relation.includes("Spouse") && gender === "Male") {
          relation = "husband";
        } else if (relation.includes("Spouse") && gender === "Female") {
          relation = "wife";
        } else if (relation.includes("Child") && gender === "Female") {
          relation = "daughter";
        }
        return {
          empId: element.empId,
          name:element.name,
          age:element.age,
          gender:element.gender,
          email:element.email,
          sumInsured: element.sumInsured,
          doj: element.doj,
          mobile: element.mobile,
          cardNo: element.cardNo,
          actionType: "Deletion",
          relation: relation,
          dob:element.dob?element.dob:'1970-01-01',
          leavingDate:element.dor
        };
      });
      
      let saveEndoPayload={
        manager:{
          "mobile":localStorage.getItem("mobileNumber"),
          "policyNum":this.policyNumber,
          "startdate":this.startDate,
          "enddate":this.endDate,
          "insurer":"app",
          "source":"app"
        },
        userList:
        mapArr
      }
      this.commonPayload(saveEndoPayload,"Deletion")
    }

    }
  };

  confirmDeleteEndo=(endoresementType)=>{
    // if(this.sumInsuredCalc+this.holdCdBalance>this.cdBalance && endoresementType==="Addition"){
    //   this.toasterService.showErrorToasterEndo("Your endorsement cannot be processed due to insufficient CD Balance. Please top up your CD Balance to proceed with the endorsement.");
    //   }
    //   else{
       let timer = setTimeout(() => {
          this.loading = false;
          this.deleteModalProceedOpen = false;
          this.blurBackGround=false;
          this.selectAll=false
          this.toasterService.showErrorToasterEndo("Endorsement batch creation is in progress, please check after some time.");
        },60000)

        this.loading=true;
        let employeeList=[]
        for (let i  = 0;  i< this.storeCardsArr.length; i++) {
          let obj={
            serialNumber:i+1,
            employeeNumber:this.storeCardsArr[i].empId,
            insuredName:this.storeCardsArr[i].name,
            gender:this.storeCardsArr[i].gender,
            dateOfBirth:this.storeCardsArr[i].dob,
            dateOfResignation:endoresementType==="Deletion"?this.storeCardsArr[i].dor:null,
            dateOfJoining:endoresementType==="Addition"?this.storeCardsArr[i].doj:null,
            email:this.storeCardsArr[i].email,
            endorsementType:endoresementType,
            relationshipType:this.storeCardsArr[i].relation,
            mobile:this.storeCardsArr[i].mobile,
            sumInsured:this.storeCardsArr[i].sumInsured,
          }
          employeeList.push(obj)
        }
       let saveEndoPayload={
        policyNumber:this.policyNumber,
        batchSource: "Endorsement Portal",
        employeesList:employeeList
       }
        this.serviceURLService.saveEndoresmentApiForApp(saveEndoPayload).subscribe(
            (successData: any) => {
              this.loading = false;
              const targetArray = this.storeCardsArr.map((obj) => obj._id);
              this.deleteModalProceedOpen=false;
                this.blurBackGround=false;
                clearTimeout(timer);
                window.location.reload()
              this.getAllActiveEcards(this.endDate);
               let data=successData.response.pamResponse
               if(data.status!=400){
                 if(endoresementType==="Deletion"){
                this.serviceURLService.deleteActiveEcards({ userIdList: targetArray }).subscribe(
                  (successData: any) => {
                    this.loading = false;
                    this.deleteModalProceedOpen=false;
                    this.deleteModalOpen=false
                    clearTimeout(timer);
                    window.location.reload()
                    this.toasterService.showErrorToasterEndo("Deletion Batch created successfully");
                    this.storeCardsArr=[];
                  },
                  (errorData) => {
                    this.loading = false;
                  }
                );
              }
              else{
              this.toasterService.showErrorToasterEndo("Endorsement batch created successfully");
              }
               }
               else{
              this.toasterService.showErrorToasterEndo(data.message);
               }
              
              this.selectAll=false
              setTimeout(() => {
                window.location.reload()
              }, 4000);
            },
            (errorData) => {
              this.loading = false;
            }
          );
      // }
  }

  closeProceedDeleteModal = () => {
    this.deleteModalProceedOpen = false;
    this.blurBackGround=false;
    if(this.typeOfForBtns==='add'){
      this.storeCardsArr=[]
      for (let index = 0; index < this.activeCardArr.length; index++) {
       this.activeCardArr[index].isChecked=false
       if(index%2==0){
        this.activeCardArr[index].bgColor='white'
      }
      else{
        this.activeCardArr[index].bgColor='#e8eaee'
      }
      }
    }
    this.selectAll=false
  };

  calulateCardName=(insurerCode,product,policyNo)=>{
    let InsurerCode= insurerCode?insurerCode:"NA";
        if (product=="Group Daily Cash Allowance (DCA)"){
            product="Group Daily Cash Allowance";
        }
        let productName=product?product:"Group health Insurance";
        let productarray=productName.split(" ")
        product=""
        productarray.map(firstcharacter=>{ 
            product=product+firstcharacter[0]})
        let cardName=product+"_"+InsurerCode+"_"+policyNo;
        return cardName
  }

  onMouseEnter=(index)=>{
    this.activeCardArr[index].bgColor='#f5f8c4'
  }
  onMouseLeave=(index)=>{
    if(!this.activeCardArr[index].isChecked){
      if(index%2==0){
        this.activeCardArr[index].bgColor='white'
      }
      else{
        this.activeCardArr[index].bgColor='#e8eaee'
      }
    }
    
  }
  clickonRow = (card) => {
    card.isChecked = !card.isChecked;
    card.bgColor = card.isChecked ? '#f5f8c4' : '';
    if (card.isChecked) {
      this.storeCardsArr.push(card);
      this.activeCardArr.forEach((element) => {
        if (element.empId === card.empId && card.relation.toLowerCase()=="self"&&!this.storeCardsArr.includes(element)) {
          if(element.cardNo!="Endorsement-Pending"){
          this.storeCardsArr.push(element);
          element.isChecked=true
        }
      }
      });
    } else {
      const index = this.storeCardsArr.indexOf(card);
      if (index !== -1) {
        this.storeCardsArr.splice(index, 1);
      }
    }
    if(this.typeOfForBtns==="add"){
      // const dateCreated =new Date( this.storeCardsArr[0].doj);
      //   const formattedDate = this.datePipe.transform(dateCreated,"dd/MM/yyyy" );
      this.editObj={...this.storeCardsArr[0]}
    }
    else if(this.typeOfForBtns==="edit"){
      this.editObj={...this.storeCardsArr[0],_id:this.storeCardsArr[0].id}
    }
    this.toggleForFamDelete = Array(this.storeCardsArr.length).fill({ toggleDateForSelf: false,toggleDateForDob:false });
    };
  
    globalSearchFilter(searchTerm: string) {
      this.searchVal=searchTerm
      if (!searchTerm) {
        this.activeCardArr = this.filteredItems; // Reset to show all items
        return;
      }
  
      const lowerCaseSearch = searchTerm.toLowerCase();
      this.activeCardArr = this.filteredItems.filter(item =>
        Object.values(item).some(val =>
          val&&val.toString().toLowerCase().includes(lowerCaseSearch)
        )
      );
    }

    selectEveryRow=()=>{
      if(this.selectAll){
        for (let index = 0; index < this.activeCardArr.length; index++) {
          if(this.activeCardArr[index].cardNo!="Endorsement-Pending"){
         this.activeCardArr[index].isChecked=this.selectAll;
        this.storeCardsArr.push(this.activeCardArr[index]);
        this.toggleForFamDelete = Array(this.storeCardsArr.length).fill({ toggleDateForSelf: false,toggleDateForDob:false });
        this.toggleForFam = Array(this.familyDefitionArr.length).fill({ toggleDateForSelf: false });
        }
      }
      }
      else{
        for (let index = 0; index < this.activeCardArr.length; index++) {
          this.activeCardArr[index].isChecked=false
         }
        this.storeCardsArr.splice(0,this.storeCardsArr.length)
      }
      for (let i = this.storeCardsArr.length - 1; i >= 0; i--) {
        if (this.storeCardsArr.indexOf(this.storeCardsArr[i]) !== i) {
          this.storeCardsArr.splice(i, 1);
        }
      }
}

handleLeavingDate=(event,i)=>{
  const{name,value}=event.target;
  if(name==='dob'){
    this.storeCardsArr[i].dob=value
  this.toggleForFamDelete[i] = { ...this.toggleForFamDelete[i], toggleDateForDob: true };
  }
  else{
    if(this.storeCardsArr[0].relation.toLowerCase() === 'self'){
      this.storeCardsArr[0].dor=i==0?value:this.storeCardsArr[0].dor
      this.storeCardsArr.forEach((element,j) => {
        if(element.empId===this.storeCardsArr[0].empId){
        this.storeCardsArr[j]={...element,dor:this.storeCardsArr[0].dor}
        }
        else{
          this.storeCardsArr[i].dor=value
        }
        })
      }
    else{
    this.storeCardsArr[i].dor=value
    }
  this.toggleForFamDelete[i] = { ...this.toggleForFamDelete[i], toggleDateForSelf: true };
  }
}

endorsementBatches=async()=>{
this.endorsementBatchModal=true;
this.blurBackGround=true;
this.loading=true
let payload={
  cardName:this.calculateCardName,
  endDate:this.endDate
}
this.serviceURLService.getAllBatchForThePolicyApi(this.policyNumber,this.startDate,this.endDate).subscribe((successData: any) => {
  this.endoBatchesArr=successData.response.pamResponse.data?successData.response.pamResponse.data:[]
  this.serviceURLService.getAllUpdationBatches(payload).subscribe((successData: any) => {
    this.endoBatchesArr=successData.response?this.endoBatchesArr.concat(successData.response):[]
        this.loading = false;
  }, errorData => {
        this.loading = false;
  });
}, errorData => {
  this.loading=false;
  this.serviceURLService.getAllUpdationBatches(payload).subscribe((successData: any) => {
    this.endoBatchesArr=successData.response
    this.loading = false;
  }, errorData => {
    this.loading = false;
  });
});
  
}

closeEndoresementBatchModal=()=>{
  this.endorsementBatchModal=false;
  this.blurBackGround=false;
}
closeEndoresementEmployeeBatchModal=()=>{
  this.employeesByBatchIdModal=false;
}
closeEndoresementBatchDetailsModal=()=>{
  this.batchDetailsFromBatchIdModal=false;
}
viewEmployeeByBatchId=(batchId,batchType)=>{
this.employeesByBatchIdModal=true;
this.blurBackGround=true;
this.loading=true;
this.batchType=batchType
if(batchType!=="updation"){
  this.serviceURLService.getAllEmployeesFromBatch(batchId).subscribe((successData: any) => {
    this.employeeByBatchArr=successData.response.pamResponse.data
    this.loading=false;
        }, errorData => {
          this.loading=false
        });
}
else{
  this.serviceURLService.allEmployeesFromBatchWithUpdate(batchId).subscribe((successData: any) => {
    this.employeeByBatchArr=successData.response
    this.loading=false;
        }, errorData => {
          this.loading=false
        });
}
}

viewBatchDetailsByBatchId=(batchId)=>{
  this.batchDetailsFromBatchIdModal=true;
  this.blurBackGround=true;
  this.loading=true;
  this.serviceURLService.getBatchDetailsFromBatchIdApi(batchId).subscribe((successData: any) => {
    let data=successData.response.pamResponse.data
    this.batchDetailsFromBatchObj.batchPremium=data.batchPremium?data.batchPremium:''
    this.batchDetailsFromBatchObj.approvedAmount=data.approvedAmount?data.approvedAmount:""
    this.batchDetailsFromBatchObj.endorsementPolicyNumber=data.endorsementPolicyNumber?data.endorsementPolicyNumber:''
    this.loading=false;
        }, errorData => {
          this.loading=false
        });
  }

  updateEmployees=async()=>{
    try {
      // const documentLink = await this.getLinkFromExcelUpload();
    let employeeToUpdate={};
    let i=this.toDelete
    // for (let i = 0; i < this.storeCardsArr.length; i++) {
       employeeToUpdate={
        "cardName":this.calculateCardName,
        "name": this.storeCardsArr[i].name,
        "email": this.storeCardsArr[i].email,
        "doj": this.storeCardsArr[i].doj,
        "dob":this.storeCardsArr[i].dob,
        "mobile":this.storeCardsArr[i].mobile,
        "relation":this.storeCardsArr[i].relation,
        "empId":this.storeCardsArr[i].empId,
        "age":this.storeCardsArr[i].age,
        "userId":this.typeOfForBtns==='edit'?this.storeCardsArr[i].userId: this.storeCardsArr[i].user,
        "policyId": this.typeOfForBtns==='edit'?this.storeCardsArr[i].policyId:this.storeCardsArr[i]._id,
        "createdBy": localStorage.getItem("userID"),
        "policyEndDate":this.endDate,
        "cardNo":this.storeCardsArr[i].cardNo,
        "gender":this.storeCardsArr[i].gender,
        "sumInsured":this.storeCardsArr[i].sumInsured,
        "uploadType":this.storeCardsArr[i].uploadType,
        "updatedColumns":this.updatedColumn,
        "documentLink":"https://static-files-website.s3.amazonaws.com/notify/20240617175715-5357app1.png",
        "documentType":this.storeCardsArr[i].documentType
    }
    if (this.typeOfForBtns === 'edit') {
      employeeToUpdate["_id"] = this.storeCardsArr[i]._id;
    }
    
    // }
    this.serviceURLService.updateEmployeeEndoApi(employeeToUpdate).subscribe((successData: any) => {
      this.updateSuccessMessage = "Changes Saved !";
      if(this.typeOfForBtns==='view'){
        this.toasterService.showErrorToasterEndo("Employees(s) moved to Updation successfully");
      }
      this.typeOfForBtns="edit"
      this.headerType="Updation";
      this.updateEmployeeModal=false
      this.editModalBool=false;
      this.updateModalBool=false
      this.inProgressBtnFlag=true
      this.editModalOpen=false
      this.getAllActiveEcards(this.endDate);
      this.updatedColumn=[]
      this.storeCardsArr.splice(this.toDelete,1)
      // if(this.storeCardsArr.length==0){
        // this.updateEmployeeModal=false;
        this.blurBackGround=false;
      // }
      setTimeout(() => {
      this.updateSuccessMessage = "";
      }, 5000); // 5000 milliseconds = 5 seconds
      this.loading=false;
          }, errorData => {
            this.loading=false
          });
  } catch (error) {
    console.error('Error uploading document:', error);
  }
  }
  compareKeysWithArray(obj, arr) {
    return Object.keys(obj).every(key => arr.includes(key));
  }
  onFileChange = async (event) => {
    this.loading = true;
    let columnsOfExcel = ["SerialNo.", "Endorsement Type", "EmployeeID.", "Name", "DateofBirth(YYYY-MM-DD)", "Relationship", "Gender(Male/Female)",
      "SumInsured", "DateofJoining(YYYY-MM-DD)", "DateofResignation(YYYY-MM-DD)", "MobileNumber", "Email", "DateofMarriage(YYYY-MM-DD)", "Card Number (for deletion cases only)"];
    
    const file = event.target.files[0];
    this.uploadedFileName=file.name
    if (file) {
      const reader = new FileReader();
      
      reader.onload = async (e: any) => {
        const binaryString = e.target.result;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        this.excelUploadData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
  
        if (this.excelUploadData.length > 300) {
          this.excelValMessage = "Upload limit exceeded: Only 300 records are allowed per upload";
          this.loading = false;
          return
        }
        // Step 1: Fetch parent users from API
        const mobileNumbers = this.excelUploadData
        .map(entry => entry['MobileNumber'] ? String(entry['MobileNumber']) : null)
        .filter(Boolean); // Filter out undefined, null, or empty numbers      
        let apiResponse = {};
      await this.serviceURLService.getParentsData({"mobiles":mobileNumbers}).subscribe((successData: any) => {
          apiResponse = successData.response
          let selfEntries = {};
          for (let i = 0; i < this.excelUploadData.length; i++) {
            this.excelUploadData[i]['DateofBirth(YYYY-MM-DD)'] = this.validateExcelDates(this.excelUploadData[i]['DateofBirth(YYYY-MM-DD)']);
            this.excelUploadData[i]['DateofJoining(YYYY-MM-DD)'] = this.validateExcelDates(this.excelUploadData[i]['DateofJoining(YYYY-MM-DD)']);
            this.excelUploadData[i]['DateofResignation(YYYY-MM-DD)'] = this.validateExcelDates(this.excelUploadData[i]['DateofResignation(YYYY-MM-DD)']);
    
            const dob = new Date(this.excelUploadData[i]['DateofBirth(YYYY-MM-DD)']);
            dob.setHours(0, 0, 0, 0);
            const eighteenYearsAgo = new Date();
            eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 25);
            eighteenYearsAgo.setHours(0, 0, 0, 0);
            const currentDate = new Date();
            const thirtyDaysAgo = new Date(currentDate);
            thirtyDaysAgo.setDate(currentDate.getDate() - 30);
            let relation = this.excelUploadData[i].Relationship;
            
            if (!this.excelUploadData[i]['Name']) {
              this.excelValMessage = "Name is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (!this.excelUploadData[i]['EmployeeID.']) {
              this.excelValMessage = "Employee ID is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (!this.excelUploadData[i]['Endorsement Type']) {
              this.excelValMessage = "Endorsement type is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (!this.excelUploadData[i]['DateofBirth(YYYY-MM-DD)']) {
              this.excelValMessage = "Date of birth is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (!relation) {
              this.excelValMessage = "Relationship is required , Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (!this.excelUploadData[i]['Gender(Male/Female)']) {
              this.excelValMessage = "Gender is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (!this.excelUploadData[i]['SumInsured']) {
              this.excelValMessage = "Sum Insured is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (this.excelUploadData[i]['SumInsured'] < 0) {
              this.excelValMessage = "Sum Insured cannot be less than 0, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (this.excelUploadData[i]['Endorsement Type'].toLowerCase() === "addition" && !this.excelUploadData[i]['DateofJoining(YYYY-MM-DD)']) {
              this.excelValMessage = "Date of joining is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (this.excelUploadData[i]['Endorsement Type'].toLowerCase() === "addition" && new Date(this.excelUploadData[i]['DateofJoining(YYYY-MM-DD)']) < thirtyDaysAgo) {
              this.excelValMessage = "Employee date of joining can't be greater than 30 days from today , Error on rowNo:" + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (this.excelUploadData[i]['Endorsement Type'].toLowerCase() === "deletion" && !this.excelUploadData[i]['DateofResignation(YYYY-MM-DD)']) {
              this.excelValMessage = "Date of resignation is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if (this.excelUploadData[i]['Endorsement Type'].toLowerCase() === "deletion" && !this.excelUploadData[i]['Card Number (for deletion cases only)']) {
              this.excelValMessage = "Card Number is required, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
            }
            else if ((relation.toLowerCase() === "child" || relation.toLowerCase() === "son" || relation.toLowerCase() === "daughter") && dob < eighteenYearsAgo) {
              this.excelValMessage = relation + " Date of birth should not be 25 years or above, Error on rowNo: " + Number(i + 1);
              this.loading = false;
              break;
          }          
    
            // Validation: Date of joining should not be earlier than the policy start date
            const policyStartDate = new Date(this.startDate.replace(/-/g, "/"));
            const joiningDate = new Date(this.excelUploadData[i]['DateofJoining(YYYY-MM-DD)']);
            if (joiningDate < policyStartDate) {
              this.excelValMessage = 'Joining Date is earlier than Policy Start Date, Error on rowNo: ' + Number(i + 1);
              this.loading = false;
              break;
            }
    
            // Validation: Either mobile number or email is mandatory
            if (!this.excelUploadData[i]['MobileNumber'] && !this.excelUploadData[i]['Email']) {
              this.excelValMessage = 'Either mobile number or email is mandatory, Error on rowNo: ' + Number(i + 1);
              this.loading = false;
              break;
            }
    
            // Track Self entries by mobile number
            const mobileNumber = this.excelUploadData[i]['MobileNumber'];
            if (relation.toLowerCase().includes("self")) {
              selfEntries[mobileNumber] = true;
            }
            console.log(apiResponse,'api')
            this.loading = false;
            // Additional validation: Check for Child entries without corresponding Self entries for existing active excard dependents
            if ((relation.toLowerCase() === "child" || relation.toLowerCase() === "son" || relation.toLowerCase() === "daughter") && new Date(this.excelUploadData[i]['DateofBirth(YYYY-MM-DD)']) < thirtyDaysAgo) {
              if (apiResponse[mobileNumber]) {
                this.excelValMessage = "Date of Birth can't be greater than 30 days, Error on rowNo: " + Number(i + 1);
                break;
              }else if (!selfEntries[mobileNumber]) {
                this.excelValMessage = 'The parent record does not exist, Error on rowNo: ' + Number(i + 1);
                break;
              }
            }
    
            // Additional validation: Check for Spouse entries with Date of Marriage
            if (relation.toLowerCase().includes("spouse") && new Date(this.excelUploadData[i]['DateOfMarriage(YYYY-MM-DD)']) < thirtyDaysAgo) {
              if (apiResponse[mobileNumber]) {
                this.excelValMessage = "Marriage Certificate Date cannot be more than 30 days, Error on rowNo: " + Number(i + 1);
                break;
              }
            }

            if (!!this.familyDefinitionFlag) {
              const familyDef = this.familyDefinitionFlag.toLowerCase();
              relation = relation.toLowerCase();
              switch (familyDef) {
                case 'self':
                  if (relation !== 'self') {
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break;
                case 'self + spouse':
                  if (relation !== 'self' && relation !== 'wife' && relation !== 'husband') {
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break;

                case 'self + spouse + kids':
                  if (relation === 'father' || relation === 'mother' || relation === 'father in law' || relation === 'mother in law') {
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break;

                case 'self + spouse + kids + parents':
                  if (relation === 'father in law' || relation === 'mother in law') {
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break;

                case 'self + spouse + kids + in laws (mother/father)':
                  if (relation === 'father' || relation === 'mother') {
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break;
                case '2 parents':
                  if(relation !== 'father' && relation !== 'mother'){
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break;
                case 'self + 2 parents':
                  if(relation !== 'self' && relation !== 'father' && relation !== 'mother'){
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break; 
                case 'self + spouse + kids + parents + parent in laws':
                  const allowedRelations = ['self', 'father', 'mother', 'father in law', 'mother in law', 'wife', 'husband', 'son', 'daughter'];
                  if (!allowedRelations.includes(relation)) {
                    this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                    return;
                  }
                  break;
                case 'self + spouse + kids + parents/parent in laws':
                  if(relation === 'father in law' || relation === 'mother in law' || relation === 'father' || relation === 'mother'){
                    this.validateRelationship();
                    if(!this.isValidRelation){
                      this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}, Parents 
                        cannot coexist with Parents in laws`
                      return;
                    }
                  }
                  break;
                  case '2 parents/parent in laws':
                    if(relation === 'father in law' || relation === 'mother in law' || relation === 'father' || relation === 'mother'){
                      this.validateRelationship();
                      if(!this.isValidRelation){
                        this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}, Parents 
                          cannot coexist with Parents in laws`
                        return;
                      }
                    }else{
                      this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                        return;
                    }
                  break; 
                  case 'self + 2 parents/parent in laws':
                    if(relation === 'self'){
                      break;
                    }else if(relation === 'father in law' || relation === 'mother in law' || relation === 'father' || relation === 'mother'){
                      this.validateRelationship();
                      if(!this.isValidRelation){
                        this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}, Parents 
                          cannot coexist with Parents in laws`
                        return;
                      }
                    }else{
                      this.excelValMessage = `Row no. ${Number(i + 1)}: Please verify the relation as per the family definition: ${familyDef}`
                        return;
                    }
                  break;
                default:
                  this.excelValMessage = '';
              }
            }
          }
        }, errorData => {
          apiResponse={}
          this.loading = false;
        })
  
      
  
        const keysMatch = this.excelUploadData.length > 0 ? this.compareKeysWithArray(this.excelUploadData[0], columnsOfExcel) : false;
        if (keysMatch && !this.excelValMessage) {
          this.excelValMessage = ''
        } else if (!keysMatch) {
          this.excelValMessage = "Please upload a valid excel file";
        }
      };
      reader.readAsBinaryString(file);
    }
  } 
  validateExcelDates(date){
    if(!!date){
      let formattedDate;
      let dateString;
      if(typeof date === 'number'){
        date = XLSX.SSF.parse_date_code(date);
        formattedDate = date.y + '-' + (date.m < 10 ? '0' + date.m : date.m) + '-' + (date.d < 10 ? '0' + date.d : date.d);
        dateString = formattedDate.toString()
      }else{
        dateString = date;
      }
      const dateFormatRegex = /^(?:19|20)\d{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$/;
      if(dateFormatRegex.test(dateString)){
        this.excelValMessage = '';
        return dateString
      } else {
        this.excelValMessage = 'Please provide the date in YYYY-MM-DD format';
        throw Error()
      }
    } else {
      return
    }
  }
   excelSerialToJSDate=(serial)=> {
    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const dateInfo = new Date(utcValue * 1000);
  
    const fractionalDay = serial - Math.floor(serial) + 0.0000001;
    dateInfo.setSeconds(dateInfo.getSeconds() + Math.round(fractionalDay * 86400));
    const formattedDate = this.datePipe.transform(dateInfo, 'yyyy-MM-dd');
    
    return formattedDate;
  }
  
  submitExcelData=()=>{
    this.loading=true
    if(!this.excelValMessage &&this.excelUploadData.length>0){
    let uploadData=[];
    this.excelValMessage=''
    for (let i = 0; i < this.excelUploadData.length; i++) {
       let relation = this.excelUploadData[i].Relationship.toLowerCase()
        let gender = this.excelUploadData[i]["Gender(Male/Female)"].toLowerCase();
         if (relation.includes("child") && gender === "male") {
          relation = "son";
        } else if (relation.includes("spouse") && gender === "male") {
          relation = "husband";
        } else if (relation.includes("spouse") && gender === "female") {
          relation = "wife";
        } else if (relation.includes("child") && gender === "female") {
          relation = "daughter";
        }
      let obj={
        empId:this.excelUploadData[i]['EmployeeID.']?this.excelUploadData[i]['EmployeeID.']:'',
        name:this.excelUploadData[i].Name?this.excelUploadData[i].Name:'',
        gender:this.excelUploadData[i]["Gender(Male/Female)"]?this.excelUploadData[i]["Gender(Male/Female)"]:'',
        dob:this.excelUploadData[i]['DateofBirth(YYYY-MM-DD)']?this.excelUploadData[i]['DateofBirth(YYYY-MM-DD)'].trim():'',
        relation:relation,
        sumInsured:this.excelUploadData[i].SumInsured?this.excelUploadData[i].SumInsured:'',
        doj:this.excelUploadData[i]['DateofJoining(YYYY-MM-DD)']?this.excelUploadData[i]['DateofJoining(YYYY-MM-DD)'].trim():'',
        leavingDate:this.excelUploadData[i]['DateofResignation(YYYY-MM-DD)']?this.excelUploadData[i]['DateofResignation(YYYY-MM-DD)'].trim():'',
        actionType:this.excelUploadData[i]['Endorsement Type']?this.excelUploadData[i]['Endorsement Type']:'',
        mobile: (this.excelUploadData[i].MobileNumber ? String(this.excelUploadData[i].MobileNumber).trim() : ''),
        email:this.excelUploadData[i].Email?this.excelUploadData[i].Email:'',
        cardNo:this.excelUploadData[i]['Card Number (for deletion cases only)']?this.excelUploadData[i]['Card Number (for deletion cases only)']:'',
        age:''
      }
      uploadData.push(obj)
    } 
    let saveEndoPayload={
      manager:{
        "mobile":localStorage.getItem("mobileNumber"),
        "policyNum":this.policyNumber,
        "startdate":this.startDate,
        "enddate":this.endDate,
        "insurer":"app",
        "source":"app"
      },
      userList:uploadData
    }
    this.serviceURLService.saveEmloyeeTempInNotify(saveEndoPayload).subscribe(
      (successData: any) => {
        if(successData.error){
          this.toasterService.showErrorToasterEndo("Access Denied,Please log in with the mobile number associated with the policy.");
        }else{
          this.toasterService.showErrorToasterEndo("Employee added successfully to addition queue");
        }
        this.loading = false;
        this.typeOf=''
        this.getAllActiveEcards(this.endDate);
    this.excelUploadData=[]
    this.blurBackGround=false;
    this.typeOfForBtns='add'
    this.formType="add"
    this.headerType='Addition Calculation'
    this.getAllActiveEcards(this.endDate)
    this.inProgressBtnFlag=true
    this.uploadedFileName=''
      },
      (errorData) => {
        this.loading = false;
        this.toasterService.showErrorToasterEndo(errorData.error.message);
      }
    );
    }
    else{
      this.excelValMessage="Please upload excel file";
      this.loading = false;
    }
  }

  editModalOpenFunc=()=>{
    if(this.storeCardsArr.length<=0){
      this.toasterService.showErrorToasterEndo('Please select an employee');
    }
   else if(this.storeCardsArr.length>1){
      this.toasterService.showErrorToasterEndo('You can edit one employee at a time');
    }
    else{
      this.toggleForFamEdit = { toggleDateForDob : true,toggleDateForDoj:true };
      this.editModalOpen=true;
      this.blurBackGround=true;
    }
  }

  closeEditModal=()=>{
    this.editModalOpen=false;
    this.blurBackGround=false;
    this.editModalErrorMessage=''
    if(this.typeOfForBtns==='add'){
      this.storeCardsArr=[]
      for (let index = 0; index < this.activeCardArr.length; index++) {
       this.activeCardArr[index].isChecked=false
       if(index%2==0){
        this.activeCardArr[index].bgColor='white'
      }
      else{
        this.activeCardArr[index].bgColor='#e8eaee'
      }
      }
    }
    this.selectAll=false;
  }
  
  handleChangeEmpEdit=(event)=>{
    if(this.typeOfForBtns==='add'){
    var { name, value } = event.target;
      this.editObj = {
        ...this.editObj,
      [name]: value,
      };
    }
    if(name==="dob"){
      this.toggleForFamEdit = { ...this.toggleForFamEdit, toggleDateForDob: true };
    }
    else if(name==="doj"){
      this.toggleForFamEdit = { ...this.toggleForFamEdit, toggleDateForDoj: true };
    }
  }

  editModalModalAlert=()=>{
    const policyStartDate = new Date(this.startDate.replace(/-/g, "/"));
    const joiningDate = new Date(this.editObj.doj);
    const dob = new Date(this.editObj.dob);
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    const regForEmail = RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    const currentDate=new Date()
    const thirtyDaysAgo = new Date(currentDate);
    thirtyDaysAgo.setDate(currentDate.getDate() - 30);
    if(!this.editObj.name){
      this.editModalErrorMessage="Name is required"
    }
    else if(!this.editObj.empId){
      this.editModalErrorMessage="Employee ID is required"
    }
    else if(!this.editObj.actionType){
      this.editModalErrorMessage="Endorsement type is required"
    }
    else if(!this.editObj.dob){
      this.editModalErrorMessage="Date of birth is required"
    }
    else if ((this.editObj.relation.toLowerCase()==="self"||this.editObj.relation.toLowerCase()==="spouse")&& dob > eighteenYearsAgo) {
      this.editModalErrorMessage="Date of birth should be 18 years or above"
    }
    else if ((this.editObj.relation.toLowerCase() === "son" || this.editObj.relation.toLowerCase() === "daughter") && dob < thirtyDaysAgo) {
      this.editModalErrorMessage = "Date of birth can't be greater than 30 days from today";
  }
    else if(!this.editObj.gender){
      this.editModalErrorMessage="Gender is required"
    }
    else if(!this.editObj.sumInsured){
      this.editModalErrorMessage="Sum Insured is required"
    }
    else if(this.editObj.sumInsured<0){
      this.editModalErrorMessage="Sum Insured cannot be less than 0"
    }
    else if(!this.editObj.doj){
      this.editModalErrorMessage="Date of joining is required"
    }
    else if (joiningDate < policyStartDate) {
      this.editModalErrorMessage = 'Joining Date is smaller than PolicyStartDate'
    }
    else if(!this.editObj.mobile){
      this.editModalErrorMessage="Mobile is required"
    }
    else if(!this.editObj.email){
      this.editModalErrorMessage="Email is required"
    }
     else if(!regForEmail.test(this.editObj.email)){
      this.editModalErrorMessage="Email is invalid"
    }
    else{
      this.editModalBool=true
    }
  }
  
  closeEditModalAlert=()=>{
    this.editModalBool=false
  }
  editEmployees=()=>{
    const today:Date = new Date();
    const dob:Date = new Date(this.editObj.dob);
    const ageInMilliseconds = today.getTime() - dob.getTime();
    const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // Considering leap years
    const age = Math.floor(ageInYears);

    let editPayload={
      "toUpdate":{
        "name": this.editObj.name,
        "email": this.editObj.email,
        "doj": this.editObj.doj,
        "dob":this.editObj.dob,
        "mobile":this.editObj.mobile,
        "relation":this.editObj.relation,
        "empId":this.editObj.empId,
        "age":age,
        "gender":this.editObj.gender,
        "sumInsured":this.editObj.sumInsured
      }
    }
    this.serviceURLService.editEmployeeEndoApi(this.editObj['_id'],editPayload).subscribe(
      (successData: any) => {
        this.loading = false;
        this.typeOf=''
        this.getAllActiveEcards(this.endDate);
    this.toasterService.showErrorToasterEndo('Employee details has been edited successfully');
    this.editModalBool=false
    this.storeCardsArr=[]
    this.editModalOpen=false;
    this.blurBackGround=false;
      },
      (errorData) => {
        this.loading = false;
        this.toasterService.showErrorToasterEndo(errorData.error.message);
      }
    );
  }

   SelectFamilyDefintion=(famDef)=>{
    if(this.familyDefinitionFlag.toLowerCase() === 'Self + Spouse + Kids + Parents/Parent In Laws'.toLowerCase() || this.familyDefinitionFlag.toLowerCase() === '2 Parents/Parent In Laws'.toLowerCase() || this.familyDefinitionFlag.toLowerCase() === 'Self + 2 Parents/Parent In Laws'.toLowerCase()){
      this.handleSelection(famDef);
    }
    const index = this.familyDefitionArr.indexOf(famDef);

  if (index !== -1) {
    // If famDef is already in the array, remove it
    this.familyDefitionArr.splice(index, 1);
    this.familyDataArr.splice(index,1)
  } else {
    // If famDef is not in the array, add it
    this.familyDefitionArr.push(famDef);
  }
     // Assuming familyDataArr is an array of objects
     this.toggleForFam = Array(this.familyDefitionArr.length).fill({ toggleDateForSelf: false });
   }

   handleFamilyData=(e,i)=>{
    const { name, value } = e.target;

  // Ensure that the array has enough elements
  while (this.familyDataArr.length <= i) {
    this.familyDataArr.push({});
  }

  // Update the object at the specified index
  this.familyDataArr[i] = {
    ...this.familyDataArr[i],
    [name]: value
  };

  if(name==="dob"){
    this.toggleForFam[i] = { ...this.toggleForFam[i], toggleDateForSelf: true };
  }

}
 
clickOnFamilyDetails=()=>{
  this.familyDetails=!this.familyDetails
  this.isCollapsed2 = !this.isCollapsed2;
}

toggleCollapse=()=>{
  this.isCollapsed = !this.isCollapsed;
}
clearAllFields=()=>{
  for (const key in this.empObj) {
    this.empObj[key] = "";
  }
  this.empObj['actionType']="Addition"
  this.empObj['relation']="Self"

  this.familyDataArr=[]
  this.familyDefitionArr=[]
}

calculatePremForUpdate=()=>{
  if(this.storeCardsArr.length<=0){
    this.toasterService.showErrorToasterEndo('Please select an employee');
  }
  else{
  this.deleteModalProceedOpen=true
  let newArray = [];
  for (let index = 0; index < this.storeCardsArr.length; index++) {
      let element = this.storeCardsArr[index];
      let newElement = {
          policyNumber: element.cardNo,
          additionOrDeletion: "Updation",
          employeeNumber: element.empId,
          firstName: element.name,
          relationshipType: element.relation,
          sumInsured: element.sumInsured,
          calculation: "NA",
          mobile:element.mobile,
          email:element.email

      };
      newArray.push(newElement);
  }
  
  this.proRatePremiumArray=newArray
}
}

confirmUpdateEndo=()=>{
  let objectIds = [];
  for (let index = 0; index < this.storeCardsArr.length; index++) {
      let element = this.storeCardsArr[index];
      let objectId = element['_id']; // Assuming the property name is 'id'
      objectIds.push(objectId);
  }
  
  let payLoad={
    "batchDetails": {
        "policyNumber": this.policyNumber,
        "employeeDetails":objectIds,
        "batchType": "updation",
        "cardName":this.calculateCardName,
        "endDate":this.endDate
    },
    "mailDetails": {
        "policyHolder":this.policyholder,
        "mobile":this.policyMobileNumber,
        "email":this.policyEmail,
        "insurer":this.insurerName,
        "userPolicyType":this.productName,
        "policyNumber": this.policyNumber,
        "policyEndDate":this.endDate
    }
}

this.serviceURLService.getBatchUpdateInProgress(payLoad).subscribe(
  (successData: any) => {
    this.loading = false;
    this.typeOf=''
    this.updateEmployeeModal=false;
    this.deleteModalProceedOpen=false
    window.location.reload();
    this.getAllActiveEcards(this.endDate);
  },
  (errorData) => {
    this.loading = false;
  }
);


}

focusDatesForDate=(e,name)=>{
    this.toggleDateForSelf=false
}

focusDatesForDoj=(e,name)=>{
    this.toggleDoj=false
}
focusDatesForFamDate = (e, i) => {
  this.toggleForFam[i] = { ...this.toggleForFam[i], toggleDateForSelf: false };
}
focusDatesForFamDateDelete = (e, i) => {
  this.toggleForFamDelete[i] = { ...this.toggleForFamDelete[i], toggleDateForSelf: false };
}
focusDatesForFamDobDelete = (e, i) => {
  this.toggleForFamDelete[i] = { ...this.toggleForFamDelete[i], toggleDateForDob: false };
}
focusDatesForFamDateEdit = (e, key) => {
  this.toggleForFamEdit = { ...this.toggleForFamEdit, [key]: false };
}

disableTyping(event: any) {
  event.preventDefault();
}

saveIdentityFile = (event: any) => {
  const file = event.target.files[0];
  const allowedExtensions = ["pdf", "jpeg", "jpg", "png"];
  const fileExtension = file.name.split('.').pop().toLowerCase();

  if (allowedExtensions.includes(fileExtension)) {
      this.idendtityFile = file;
  } else {
      this.uploadErrorMessage="Invalid file type. Only PDF, JPEG, JPG, and PNG files are allowed.";
      event.target.value = ''; // Optional: Reset the file input
  }
};

validateRelationship() {
  let relationMap = new Map();
  for(let i = 0; i < this.excelUploadData.length; i++){
      let empId = this.excelUploadData[i]['EmployeeID.'];
      let relation = this.excelUploadData[i].Relationship.toLowerCase();
      if(relation === 'father in law' || relation === 'mother in law'){
          if(!!relationMap.get(empId) && (relationMap.get(empId) === 'father' || relationMap.get(empId) === 'mother')){
              relationMap.clear();
              this.isValidRelation = false;
              break;
          }else{
              relationMap.clear();
              relationMap.set(empId, relation);
              this.isValidRelation = true;
              continue;
          }
      }else if(relation === 'father' || relation === 'mother'){
          if(!!relationMap.get(empId) && (relationMap.get(empId) === 'father in law' || relationMap.get(empId) === 'mother in law')){
              relationMap.clear();
              this.isValidRelation = false;
              break;
          }else{
              relationMap.clear();
              relationMap.set(empId, relation);
              this.isValidRelation = true;              
              continue;
          }
      }else{
          relationMap.clear();
          this.isValidRelation = true;  
          continue;
      }
  }
}

addDependentsFromActiveCard=(card)=>{
  this.formType="addForm";
  this.headerType="Addition Calculation";
  this.typeOfForBtns="add"
  this.empObj={...card,actionType:"Addition"},
  this.goFromActiveCardsForFamily=true
  this.goFromActiveCardsForSelf=false
  this.familyDefitionArr=[]
  this.familyDataArr=[]
}
getLinkFromExcelUpload(): Promise<any> {
  return new Promise((resolve, reject) => {
    const formData: FormData = new FormData();
    formData.append('data', JSON.stringify({ logId: localStorage.getItem("userID") }));
    formData.append('file', this.idendtityFile);

    const headers = new HttpHeaders({
      'Authorization': localStorage.getItem('authToken')
    });

    this.serviceURLService.getLinkFromExcelUpload(formData, { headers }).subscribe(
      (successData: any) => {
        console.log(successData.data[1], 'hey');
        resolve(successData.data[1]);
      },
      (errorData) => {
        this.loading = false;
        reject(errorData);
      }
    );
  });
}

async DownloadEcard(card, i) {
  console.log('Generating PDF for card:', card, i);
  
  const downloadEcardDetails = this.activeCardArr[i];
  const imageSrc = this.insuranceDetails['Insurer'];
  
  // Find insurer logo path
  let imagePath = '';
  for (let j = 0; j < this.s3LogoList.length; j++) {
      if (this.s3LogoList[j].insurerName === imageSrc) {
          imagePath = this.s3LogoList[j].logo_path;
          break;
      }
  }

  try {
      // Initialize jsPDF
      const doc = new jsPDF({
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait'
      });

      // PDF dimensions
      const pdfWidth = 145.5;
      const pdfHeight = 119.1;
      const padding = 6.6;
      const startX = (210 - pdfWidth) / 2;
      const startY = 20;

      // Colors
      const borderColor = '#d9d9d9';
      const headingColor = '#005aa9';
      const labelColor = '#5a5a5a';
      const valueColor = '#000000';

      // Draw border
      doc.setDrawColor(borderColor);
      doc.setLineWidth(0.3);
      doc.roundedRect(startX, startY, pdfWidth, pdfHeight, 5, 5, 'S');

      // Content area
      const contentX = startX + padding + 7.9;
      const contentY = startY + padding;
      const contentWidth = pdfWidth - (2 * padding) - 7.9 - 4;
      
      // Load logos with error handling
      const logos = await Promise.all([
          imagePath ? this.loadImageAsBase64(imagePath)
              .then(base64 => ({ type: 'insurer', data: base64 }))
              .catch(e => {
                  console.warn('Failed to load insurer logo:', e);
                  return { type: 'insurer', data: null };
              }) : Promise.resolve({ type: 'insurer', data: null }),
          
          this.loadImageAsBase64('../../assets/images/securenow_logo.svg')
              .then(base64 => ({ type: 'securenow', data: base64 }))
              .catch(e => {
                  console.warn('Failed to load SecureNow logo:', e);
                  return { type: 'securenow', data: null };
              })
      ]);

      // Add logos with dimensions check
      logos.forEach(logo => {
          if (!logo.data) return;
          
          try {
              if (logo.type === 'insurer') {
                  // Add insurer logo with max height constraint
                  doc.addImage(logo.data, 'PNG', startX + padding, contentY, 40, 10);
              } else if (logo.type === 'securenow') {
                  // Add SecureNow logo with fixed position
                  const logoWidth = 30;
                  const logoX = startX + pdfWidth - padding - logoWidth;
                  doc.addImage(logo.data, 'PNG', logoX, contentY + 2, 25, 5);
              }
          } catch (e) {
              console.warn(`Error adding ${logo.type} logo:`, e);
          }
      });

      // Rest of your PDF generation code remains the same...
      // Policy title
      const titleY = contentY + 20;
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(20);
      doc.setTextColor(headingColor);
      const titleText = this.insuranceDetails['policyName'] || 'Policy Name';
      const titleWidth = doc.getTextWidth(titleText);
      const titleX = startX + (pdfWidth - titleWidth) / 2;
      doc.text(titleText, titleX, titleY);

      // Details section
      const detailsStartY = titleY + 15;
      const rowHeight = 18;
      const colWidth = contentWidth / 2;
      
      // Field data
      const fields = [
          [
              { label: 'Name', value: downloadEcardDetails.name || 'NA' },
              { label: 'Policy No.', value: this.insuranceDetails['policyNo'] || 'NA' }
          ],
          [
              { label: 'Card No.', value: downloadEcardDetails.cardNo || 'NA' },
              { label: 'Sum Insured', value: downloadEcardDetails.sumInsured || 'NA' }
          ],
          [
              { label: 'Employee Id', value: downloadEcardDetails.empId || 'NA' },
              { label: 'Policy End Date', value: this.insuranceDetails['endDate'] || 'NA' }
          ],
          [
              { label: 'Age', value: downloadEcardDetails.age || 'NA' },
              { label: 'TPA Name', value: this.insuranceDetails['TPA_NAME'] || 'NA' }
          ]
      ];

      // Add field rows
      fields.forEach((row, rowIndex) => {
          const rowY = detailsStartY + (rowIndex * rowHeight);
          
          row.forEach((field, colIndex) => {
              const fieldX = contentX + (colIndex * colWidth);
              
              // Label
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(14);
              doc.setTextColor(labelColor);
              doc.text(field.label, fieldX, rowY - 2);
              
              // Value
              doc.setFont('helvetica', 'bold');
              doc.setFontSize(12);
              doc.setTextColor(valueColor);
              
              const maxWidth = colWidth - 5;
              const valueLines = doc.splitTextToSize(field.value, maxWidth);
              doc.text(valueLines, fieldX, rowY + 4);
          });
      });

      // Save the PDF
      const fileName = (this.insuranceDetails['policyNo'] || 'policy') + '.pdf';
      doc.save(fileName);
      
  } catch (error) {
      console.error('PDF generation failed:', error);
      // Fallback with delay
      await new Promise(resolve => setTimeout(resolve, 200));
      return this.DownloadEcardFallback(card, i);
  }
}

// Helper method to load images as base64 (REQUIRED)
loadImageAsBase64(imagePath) {
  return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Use capital 'A' for better compatibility
      
      img.onload = function() {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          
          // Draw white background first for transparent PNGs
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0);
          
          try {
              const dataURL = canvas.toDataURL('image/png');
              resolve(dataURL);
          } catch (e) {
              reject(e);
          }
      };
      
      img.onerror = (e) => {
          console.error('Image load error:', e);
          reject(new Error('Failed to load image: ' + imagePath));
      };
      
      // Add timestamp to bypass cache
      img.src = imagePath 
  });
}

// Fallback method (your original implementation optimized)
async DownloadEcardFallback(card, i) {
  console.log('Using fallback PDF generation method');
  
  const snLogo = '../../assets/images/securenow_logo.svg';
  const downloadEcardDetails = this.activeCardArr[i];
  const imageSrc = this.insuranceDetails['Insurer'];
  
  let imagePath = '';
  for (let j = 0; j < this.s3LogoList.length; j++) {
      if (this.s3LogoList[j].insurerName === imageSrc) {
          imagePath = this.s3LogoList[j].logo_path;
          break;
      }
  }

  const content = `
  <!DOCTYPE html>
  <html lang="en">
  <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>E-Card</title>
      <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          .pdf-content-to-download {
              width: 550px;
              height: 450px;
              padding: 25px;
              border-radius: 20px;
              border: solid 1px #d9d9d9;
              background: white;
              font-family: Arial, sans-serif;
          }
          .headingOfPdf {
              font-size: 23px;
              font-weight: bold;
              color: #005aa9;
              text-align: center;
              margin: 15px 0;
          }
          .insurer-logo {
              height: 54px;
              object-fit: contain;
          }
          .securenow-logo {
              height: 22px;
              width: auto;
              object-fit: contain;
          }
          .field-label {
              font-size: 16px;
              color: #5a5a5a;
              font-weight: 500;
              margin-bottom: 2px;
          }
          .field-value {
              font-size: 14px;
              color: #000000;
              word-break: break-word;
              font-weight: bold;
              margin-bottom: 15px;
          }
          .content-section {
              padding-left: 30px;
              padding-right: 15px;
              margin-top: 15px;
          }
          .header-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
          }
          .details-row {
              display: flex;
              margin-bottom: 15px;
          }
          .details-col {
              flex: 1;
              padding-right: 15px;
          }
          .details-col:last-child {
              padding-right: 0;
              padding-left: 15px;
          }
      </style>
  </head>
  <body>
      <div class="pdf-content-to-download">
          <div class="header-row">
              <img class="insurer-logo" src="${imagePath}" alt="insurer logo">
              <img class="securenow-logo" src="${snLogo}" alt="securenow logo">
          </div>
          
          <h1 class="headingOfPdf">${this.insuranceDetails['policyName'] || 'Policy Name'}</h1>
          
          <div class="content-section">
              <div class="details-row">
                  <div class="details-col">
                      <div class="field-label">Name</div>
                      <div class="field-value">${downloadEcardDetails.name || 'NA'}</div>
                  </div>
                  <div class="details-col">
                      <div class="field-label">Policy No.</div>
                      <div class="field-value">${this.insuranceDetails['policyNo'] || 'NA'}</div>
                  </div>
              </div>
              
              <div class="details-row">
                  <div class="details-col">
                      <div class="field-label">Card No.</div>
                      <div class="field-value">${downloadEcardDetails.cardNo || 'NA'}</div>
                  </div>
                  <div class="details-col">
                      <div class="field-label">Sum Insured</div>
                      <div class="field-value">${downloadEcardDetails.sumInsured || 'NA'}</div>
                  </div>
              </div>
              
              <div class="details-row">
                  <div class="details-col">
                      <div class="field-label">Employee Id</div>
                      <div class="field-value">${downloadEcardDetails.empId || 'NA'}</div>
                  </div>
                  <div class="details-col">
                      <div class="field-label">Policy End Date</div>
                      <div class="field-value">${this.insuranceDetails['endDate'] || 'NA'}</div>
                  </div>
              </div>
              
              <div class="details-row">
                  <div class="details-col">
                      <div class="field-label">Age</div>
                      <div class="field-value">${downloadEcardDetails.age || 'NA'}</div>
                  </div>
                  <div class="details-col">
                      <div class="field-label">TPA Name</div>
                      <div class="field-value">${this.insuranceDetails['TPA_NAME'] || 'NA'}</div>
                  </div>
              </div>
          </div>
      </div>
  </body>
  </html>`;

  const fileName = (this.insuranceDetails['policyNo'] || 'policy') + '.pdf';
  const opt = {
      margin: 10,
      filename: fileName,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff'
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  await html2pdf().from(content).set(opt).save();
}

handleSelection(selectedRelation) {
  this.selectedRelations[selectedRelation] = !this.selectedRelations[selectedRelation];

  // Logic for updating visibility based on selections
  if (this.selectedRelations.Father || this.selectedRelations.Mother) {
    // If either Father or Mother is selected, show parents only (hide in-laws)
    this.isParentVisible = true;
    this.isInLawParentsVisible = false;
  } else if (this.selectedRelations['Father In Law'] || this.selectedRelations['Mother In Law']) {
    // If any In-Law is selected, show both parents and in-laws
    this.isParentVisible = false;
    this.isInLawParentsVisible = true;
  } else {
    // If no parents or in-laws are selected, show both parents and in-laws
    this.isParentVisible = true;
    this.isInLawParentsVisible = true;
  }
}
}
